// MATE signature sound: a short, crystalline two-note ascending "ding".
// Generated with the Web Audio API (no audio files, no dependencies).
// Browsers block audio until a trusted user gesture, so callers should invoke
// playMateChime() from within a real user event (tap/click/keydown).

let _audioCtx = null;

export const getAudioCtx = () => {
  if (typeof window === 'undefined') return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!_audioCtx) {
    try {
      _audioCtx = new AC();
    } catch (e) {
      return null;
    }
  }
  return _audioCtx;
};

export const playMateChime = () => {
  const ctx = getAudioCtx();
  if (!ctx) return;
  const start = () => {
    const now = ctx.currentTime;
    const notes = [
      { freq: 987.77, start: 0.0, dur: 0.26 }, // B5
      { freq: 1318.51, start: 0.13, dur: 0.34 }, // E6 (ascending)
    ];
    notes.forEach(({ freq, start: s, dur }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      const t = now + s;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.22, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + dur + 0.03);
    });
  };
  if (ctx.state === 'running') {
    start();
  } else {
    ctx.resume().then(start).catch(() => {});
  }
};
